import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const retryOperation = async <T>(
  operation: () => Promise<T>,
  attempts = 3,
  delay = 300,
): Promise<T> => {
  try {
    return await operation();
  } catch (error) {
    if (attempts <= 1) throw error;
    await wait(delay);
    return retryOperation(operation, attempts - 1, delay * 1.5);
  }
};

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const normalizeProgress = (progress: number): number => {
  return Math.min(1, Math.max(0, progress));
};

export const generateId = (): string => {
  return Math.random().toString(36).substring(2, 15);
};
